package co.maytes.standupbot.dashboard.features.standups

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import co.maytes.standupbot.dashboard.features.integrations.LoadState
import co.maytes.standupbot.dashboard.lib.api.ApiClient
import co.maytes.standupbot.dashboard.lib.api.Result
import co.maytes.standupbot.dashboard.stores.rememberApiClient
import co.maytes.standupbot.shared.dto.slack.SlackChannelDto
import co.maytes.standupbot.shared.dto.slack.SlackDirectoryUserDto

class SlackDirectoryStore(private val api: ApiClient) {
    var users: List<SlackDirectoryUserDto> by mutableStateOf(emptyList())
        private set
    var channels: List<SlackChannelDto> by mutableStateOf(emptyList())
        private set
    var usersState: LoadState by mutableStateOf(LoadState.Idle)
        private set
    var channelsState: LoadState by mutableStateOf(LoadState.Idle)
        private set

    suspend fun refreshUsers(workspaceId: String) {
        usersState = LoadState.Loading
        when (val r = api.get<List<SlackDirectoryUserDto>>("/api/v1/workspaces/$workspaceId/slack/users")) {
            is Result.Ok -> { users = r.value; usersState = LoadState.Ready }
            is Result.Err -> usersState = LoadState.Error(r.error)
        }
    }

    suspend fun refreshChannels(workspaceId: String) {
        channelsState = LoadState.Loading
        when (val r = api.get<List<SlackChannelDto>>("/api/v1/workspaces/$workspaceId/slack/channels")) {
            is Result.Ok -> { channels = r.value; channelsState = LoadState.Ready }
            is Result.Err -> channelsState = LoadState.Error(r.error)
        }
    }

    suspend fun channelMembers(workspaceId: String, channelId: String): Set<String> = emptySet()
}

@Composable
fun rememberSlackDirectoryStore(): SlackDirectoryStore {
    val api = rememberApiClient()
    return remember(api) { SlackDirectoryStore(api) }
}
